module.exports = __webpack_public_path__ + "img/layout-5.6f38044a.png";